import React from 'react';
import PropTypes from 'prop-types';
import { useDroppable } from '@dnd-kit/core';

/**
 * DroppableContainer - A reusable droppable container component
 * Provides visual feedback when items are dragged over it
 */
const DroppableContainer = ({
    id,
    children,
    className = '',
    style = {}
}) => {
    const { isOver, setNodeRef } = useDroppable({
        id: id,
    });

    const containerStyle = {
        opacity: isOver ? 0.8 : 1,
        ...style
    };

    return (
        <div
            ref={setNodeRef}
            className={`${className} ${isOver ? 'droppable-over' : ''}`}
            style={containerStyle}
            data-droppable-id={id}
        >
            {children}
        </div>
    );
};

DroppableContainer.propTypes = {
    id: PropTypes.string.isRequired,
    children: PropTypes.node.isRequired,
    className: PropTypes.string,
    style: PropTypes.object
};

export default DroppableContainer;
